import React from "react";
import { SelectionList, ISelectionListProps } from "./SelectionList";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IRadioListProps<T> extends Omit<ISelectionListProps<T>, "multiSelect"> {}

// eslint-disable-next-line func-style
export function RadioList<T>({ ...props }: IRadioListProps<T>) {
  return <SelectionList multiSelect={false} {...props} />;
}
